import { UserManager } from 'oidc-client-ts';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { InvalidLogin } from './components/InvalidLogin';
import { main } from './configuration';
import { config } from './configuration/config';
import {
    createLoginConfig,
    logisticsTenantMatchesEnvironment,
    resolveEnvironment,
} from './configuration/login/environmentUtils';
import { getLogisticsTenantFromToken } from './configuration/login/loginSlice';
import { store } from './configuration/setup/store';
import { configureDatadogLogging } from './logging/datadog';
import { router } from './routes/Router';

const setupConfiguration = () => {
    const environment = resolveEnvironment(window.location.hostname);

    config.environmentFromUri = environment;
    config.login = createLoginConfig(environment);

    configureDatadogLogging();
};

export const renderApplication = (userManager: UserManager) => {
    const root = createRoot(document.getElementById('root') as HTMLElement);
    const state = store.getState();
    const logisticsTenantFromToken = getLogisticsTenantFromToken(state);

    if (!logisticsTenantMatchesEnvironment(logisticsTenantFromToken, config.environmentFromUri)) {
        root.render(
            <ErrorBoundary>
                <InvalidLogin logisticsTenantFromToken={logisticsTenantFromToken} userManager={userManager} />
            </ErrorBoundary>,
        );
        return;
    }

    root.render(
        <ErrorBoundary>
            <Provider store={store}>
                <RouterProvider router={router} />
            </Provider>
        </ErrorBoundary>,
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

setupConfiguration();

if ((isDev && config.enableMockServer) || isProdPreview) {
    import('../mocks/browser').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
}

if (isProd && !isProdPreview) {
    void main(renderApplication);
}
